<template>
  <div class="container">
    <div class="header">
      <p style="color:#526069;font-size: 18px">待审核</p>
      <el-button
        type="primary"
        style="height: 35px;width: 126px;line-height: 10px;color: #fff;"
        @click="exportExcel"
      >导出报表</el-button>
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline" style="text-align: left;">
      <el-form-item label="店铺名称:">
        <el-input class="ein" v-model="formInline.user" placeholder="请输入店铺名称"></el-input>
      </el-form-item>

      <el-form-item class="efi" label="结算周期:">
        <el-select class="ein" v-model="rateIndex" placeholder="请选择提现周期">
          <el-option
            v-for="(item,index) in feeRates"
            :label="'T+'+item.day+' '+(item.feeRate*100).toFixed(1)+'%'"
            :value="index"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="header">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        style="text-align: left;"
      >
        <el-form-item label="时间范围:">
          <el-col :span="11">
            <el-date-picker
              :clearable="false"
              type="date"
              placeholder="选择查询起始时间"
              v-model="formInline.date1"
              style="width: 100%;"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-col>
          <el-col :span="2" style="text-align: center;">-</el-col>
          <el-col :span="11">
            <el-date-picker
              :clearable="false"
              type="date"
              placeholder="选择查询结束时间"
              v-model="formInline.date2"
              style="width: 100%;"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <div style="margin-right: 15px;">
        <el-button type="primary" style="height: 35px;line-height: 10px;" @click="getList(1)">查询</el-button>
        <el-button type="info" style="height: 35px;line-height: 10px;" @click="reset">重置</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      stripe
      :row-style="row"
      :header-cell-style="cell"
      style="width: 100%;"
    >
      <el-table-column align="center" prop="name" label="店铺名称" width="120"></el-table-column>
      <el-table-column align="center" prop="createTime" :formatter="dateFormat" label="提现时间" width="100"></el-table-column>
      <el-table-column align="center" prop="withdrawable" label="当前可提现" width="120"></el-table-column>
      <el-table-column align="center" prop="source" label="提现渠道" width="100"></el-table-column>
      <el-table-column align="center" prop="amount" :formatter="toFixed" label="本次提现"></el-table-column>
      <el-table-column
        align="center"
        prop="successCashAmount"
        :formatter="toFixed"
        :render-header="renderHeaderOne"
        label="待转账"
        width="100"
      ></el-table-column>
      <el-table-column
        align="center"
        width="100"
        prop="invoiceAmount"
        :formatter="toFixed"
        :render-header="renderHeaderTurn"
        label="待交发票"
      ></el-table-column>
      <el-table-column align="center" prop="profit" :formatter="toFixed" label="手续费"></el-table-column>
      <el-table-column align="center" prop="feeRate" :formatter="tempFormat" label="结算周期"></el-table-column>
      <el-table-column align="center" label="操作" style="text-align: center;">
        <template slot-scope="scope">
          <el-button @click="detail(scope.row.accountNo)" type="text" size="small">交易数据</el-button>
          <el-button type="text" size="small" @click="showEnsure(scope.row)">审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagi"
      background
      layout="prev, pager, next,jumper"
      :total="total"
      @current-change="getList"
    ></el-pagination>

    <el-dialog title="提现审核" :visible.sync="ensureVisible" width="30%">
      <div>
        <div class="ensure">
          <span class="ensure-name">提现金额</span>
          <span class="ensure-value">{{currentData.amount}}</span>
        </div>
        <div class="ensure">
          <span class="ensure-name">提现描述</span>
          <span class="ensure-value">{{currentData.platfSubject?currentData.platfSubject:'请尽快办理谢谢'}}</span>
        </div>
        <div class="ensure">
          <span class="ensure-name">审核结果</span>
          <el-select class="ensure-value-container" v-model="ensure.status" placeholder="请选择">
            <el-option label="不通过" value="4"></el-option>
            <el-option label="通过" value="1"></el-option>
          </el-select>
        </div>
        <div class="ensure">
          <span class="ensure-name">审核描述</span>
          <el-input
            class="ensure-value-container"
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="ensure.subject"
          ></el-input>
        </div>
        <div
          style="height: 1px;width: 100%;background-color: #f2f2f2;margin-top: 10px;margin-bottom: 10px"
        ></div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancle">取 消</el-button>
        <el-button type="primary" @click="ensureOrder">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getFeeRate, getWaitPassList, ensureOrder } from "@/api/finance";
import { compareTime } from "@/utils";
import { toFixed } from "@/utils";
import { downloadExcel } from "@/utils/downloadFetch";
import {shop_url} from '@/global';

export default {
  name: "",
  props: [""],
  data() {
    return {
      formInline: {
        user: "",
        feeRate: "",
        day: "",
        type: "",
        date1: "", //其实后台接受的参数是start和end 我也不知道为啥非写date1，date2 还要转化一下
        date2: ""
      },
      rateIndex: "",

      tableData: [],
      ensureVisible: false,
      feeRates: [],
      total: 0,
      page: 1,
      pageSize: 10,
      currentData: "",
      ensure: {
        subject: "",
        orderId: "",
        money: "",
        status: "", //1 通过  4 不通过
        mchId: ""
      }
    };
  },
  mounted() {
    this.getFeeRates();
    this.getList(1);
  },
  methods: {
    cancle() {
      this.ensureVisible = false;
      this.ensure = {
        subject: "",
        orderId: "",
        money: "",
        status: "",
        mchId: ""
      };
    },
    cell() {
      return {
        textAlign: "center",
        color: "#526069",
        fontSize: "14px"
      };
    },
    row() {
      return {
        height: "36px",
        textAlign: "center",
        color: "#7d8893",
        fontSize: "14px"
      };
    },
    getFeeRates() {
      getFeeRate().then(res => {
        console.log(res.data.data);
        this.feeRates = res.data.data;
      });
    },
    getList(page) {
      this.page = page;

      if (this.rateIndex) {
        let { day, feeRate } = this.feeRates[this.rateIndex];
        this.formInline.day = day;
        this.formInline.feeRate = feeRate;
      }

      let { date1, date2 } = this.formInline;

      let flag = compareTime(date1, date2);
      if (flag) {
        getWaitPassList(this.formInline, this.page, this.pageSize).then(res => {
          this.tableData = res.data.list;
          this.total = parseInt(res.data.count);
        });
      } else {
        this.$notify({
          title: "提示",
          message: "请正确选择时间",
          type: "warning",
          duration: 800
        });
      }
    },
    detail(mchId) {
      this.$router.push({
        path: "/main/details",
        query: { id: mchId }
      });
    },
    reset() {
      this.formInline = {
        user: "",
        feeRate: "",
        day: "",
        type: "",
        date1: "",
        date2: ""
      };
      this.rateIndex = "";
    },
    renderHeaderOne(h, { column, $index }) {
      console.log("in render");
      return h("div", [
        h("span", column.label),
        h(
          "el-tooltip",
          [
            h("i", {
              class: "el-icon-warning",
              style: "color:#409eff;margin-left:5px;"
            }),
            h(
              "p",
              {
                slot: "content",
                placement: "right-end"
              },
              "待转账金额 = 本次提现金额 - 手续费"
            )
          ],
          {
            placement: "right-end"
          }
        )
      ]);
    },
    renderHeaderTurn(h, { column, $index }) {
      console.log("in render");
      return h("div", [
        h("span", column.label),
        h(
          "el-tooltip",
          [
            h("i", {
              class: "el-icon-warning",
              style: "color:#409eff;margin-left:5px;"
            }),
            h(
              "p",
              {
                slot: "content",
                placement: "right-end"
              },
              "消费者使用润泽钱包支付的金额商家提现时需要提供发票"
            )
          ],
          {
            placement: "right-end"
          }
        )
      ]);
    },
    /* 导出报表 */
    exportExcel() {
      this.formInline.status = "101"; //倒出报表时需要的一个属性
      if (this.rateIndex) {
        let { day, feeRate } = this.feeRates[this.rateIndex];
        this.formInline.day = day;
        this.formInline.feeRate = feeRate;
      }
      let { date1, date2 } = this.formInline;
      let flag = compareTime(date1, date2);
      if (flag) {
        this.formInline.start = date1;
        this.formInline.end = date2;
        downloadExcel({
          method: "post",
          fileName: "商户交易数据报表.xls",
          url: `${shop_url}/shop/cms/print/withdraw`,
          data: this.formInline
        }).then(res => {
          console.log(res);
        });
      }
    },
    dateFormat(row, column) {
      return this.uwsToDate(row[column.property]);
    },
    tempFormat(row, column) {
      let day = row.day;
      let tpl = row[column.property];
      return "T+" + day + " " + tpl * 100 + "%";
    },
    showEnsure(data) {
      console.log(data);
      this.ensureVisible = true;
      this.currentData = data;
      this.currentData.amount = toFixed(data.amount);
    },
    ensureOrder() {
      console.log(this.currentData);
      this.ensure.money = this.currentData.amount;
      this.ensure.mchId = this.currentData.accountNo;
      this.ensure.orderId = this.currentData.orderId;
      if (!this.ensure.status) {
        this.$message({
          message: "请选择审核结果",
          type: "error"
        });
        return;
      }
      ensureOrder(this.ensure)
        .then(res => {
          this.ensureVisible = false;
          if (res.status == 200) {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.getList(this.page);
            this.ensure.subject = "";
            this.ensure.status = "";
          } else {
            this.$message({
              message: "操作失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$message({
            message: "操作失败",
            type: "error"
          });
        });
    }
  }
};
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 30px;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  justify-content: space-between;
}

.el-input {
  border-bottom: 240px #d1dee1;
}

.ein {
  width: 240px;
}

.efi {
  margin-left: 50px;
}

.pagi {
  align-self: center;
  margin-top: 24px;
}

.ensure-button {
  width: 70%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.ensure {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.ensure-name {
  color: #666;
  font-size: 14px;
  margin-right: 20px;
  width: 80px;
}

.ensure-value {
  color: #a3a3a3;
  font-size: 14px;
}

.ensure-value-container {
  width: 80%;
}

.ensure-tips {
  text-align: left;
  width: 90%;
  color: #ff6d6d;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/finance/CashManagement.vue